import { createFileRoute } from '@tanstack/react-router';
import { ContactDetailPage, type DetailTab } from '@/components/contact-detail';

export const Route = createFileRoute('/expenses/vendors/$contactId')({
  component: Detail,
  validateSearch: (s: Record<string, unknown>): { tab?: DetailTab } =>
    s['tab'] === 'details' || s['tab'] === 'transactions' ? { tab: s['tab'] } : {},
});

function Detail() {
  const { contactId } = Route.useParams();
  const { tab = 'transactions' } = Route.useSearch();
  return <ContactDetailPage kind="vendor" id={contactId} tab={tab} />;
}
